import { ServicosAtualService } from './servicos.service';
import { ListaBase } from '././../../../shared/crud/ListaBase';
import { TranslateService } from '@ngx-translate/core';
import { ExportExcelService } from './../../../shared/excel-service/export-excel.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Table } from 'primeng/table';
import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { FiltroService } from '././../../../shared/filtro/filtro.service';
import { ServicoService } from '../../status/servico/servico-service/ServicoService';
import { ServiceAppService } from './../../../../../src/app/security/service-app.service';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-atualizar-cliente',
  templateUrl: './atualizar-cliente.component.html',
  styleUrls: ['./atualizar-cliente.component.scss']
})
export class AtualizarClienteComponent extends ListaBase implements OnInit {

  @ViewChild('dt') table: Table;

  nomeModulo: any;
  username: any;
  cols: any[];
  _selectedColumns: any[];
  filtros: any = {};
  servicoDados: any;
  carregando = false;
  dealers: any;
  selectedDealer: any;
  servicos: any;

  status: any[] = [
    { descricao: 'ATIVO' },
    { descricao: 'INATIVO' }
  ];
  selectedStatus: any;
  first: number = 0;
  pageCount: number;
  rows: number = 50;
  paginaAtual: any = 1;
  tamanhoPagina: any = 50;
  totalRegistros: any = 0;
  displayRows: number = 0;
  selectedItems: any[] = [];
  selectedDados: any[];

  dadosTranslate = {
    "Cód. Dealer": "status.servico.codigoDealer",
    "Processo": "status.servico.processo",
    "Versão": "status.servico.versao",
    "Última Comunicação": "status.servico.ultimaComunicacao"
  }

  constructor(
    private serviceClient: ServiceAppService,
    service: ServicoService,
    private atualizacoesService: ServicosAtualService,
    toastr: ToastrService,
    router: Router,
    private messageService: MessageService,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private servico: FiltroService) {
    super(service, toastr, router);
    this.filtros = {};
    this.nomeModulo = 'atualizar_cliente';
    this.username = this.atualizacoesService.getUsername();
  }

  ngOnInit(): void {

    this.buscar();
    this.preencherDealers();
    this.preencherServicos();
    this.cols = [
      { field: 'codigoDealer', header: 'Cód. Dealer' },
      { field: 'nomeDealer', header: 'Dealer' },
      { field: 'processo', header: 'Processo' },
      { field: 'versao', header: 'Versão Módulo' },
      { field: 'versaoScript', header: 'Versão Script' },
      { field: 'usuarioVerificou', header: 'Usuário Aprovação' },
      { field: 'dataVerificacao', header: 'Data da Verificação' },
      { field: 'precisaAtualizar', header: 'Atualizar' },
      { field: 'ultimaComunicacao', header: 'Última Comunicação' },
      { field: 'status', header: 'Status' }
    ];
    this._selectedColumns = this.cols;
  }


  preencherDealers() {
    this.servico.buscar('dealer')
      .then(r => {
        this.dealers = r.filtros;
      });
  }

  preencherServicos() {
    this.servico.buscar('servicos')
      .then(r => {
        this.servicos = r.filtros;
      });
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  onPageChange(event: any): void {
    if (this.selectedDealer != undefined) {
      this.paginaAtual = 1;
    } else {
      this.paginaAtual = event.page + 1;
    }
    if (this.selectedStatus != undefined) {
      this.paginaAtual = 1;
    } else {
      this.paginaAtual = event.page + 1;
    }
    this.tamanhoPagina = event.rows;
    this.displayRows = event.first;
    this.first = event.first;
    this.request(this.paginaAtual);
  }

  buscar() {
    if (this.selectedDealer != undefined) {
      this.paginaAtual = 1;
    } else {
      this.first = 0;
      this.paginaAtual = 1;
    }
    if (this.selectedStatus != undefined) {
      this.paginaAtual = 1;
    } else {
      this.first = 0;
      this.paginaAtual = 1;
    }
    this.request(this.paginaAtual);
  }

  request(page?: any) {
    this.carregando = true;
    this.serviceClient.buscarServico('/status/servico', page, this.tamanhoPagina, this.selectedDealer?.id, "SRVNBSPORTAL.EXE", this.selectedStatus?.descricao).subscribe({
      next: (res) => {
        if (res.length > 0) {
          this.servicoDados = res;
          this.totalRegistros = res[0].totalRegistros;
        } else {
          this.servicoDados = [];
          this.totalRegistros = 0;
        }
        this.carregando = false;
      },
      error: (error) => {
        this.servicoDados = [];
        this.totalRegistros = 0;
        this.carregando = false;
      }
    });
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.dealer
      || this.filtros.processo
      || this.filtros.status;
  }

btnAtualizar() {
  if (this.selectedDados != undefined && this.selectedDados.length > 0) {

    console.log('Dados selecionados:', this.selectedDados);

    this.atualizacoesService.atualizarServico(this.selectedDados, this.username).subscribe(
      () => {
        this.buscar();
        this.selectedDados = null;
      },
      () => {
        console.log('Erro ao alterar atualização do serviço.');
      }
    );

  }
}

  exportarExcel() {
    let page = 0;
    let size = 0;
    this.serviceClient.buscarServico('/status/servico', page, size, this.selectedDealer?.id, "SRVNBSPORTAL.EXE", this.selectedStatus?.descricao).subscribe({
      next: (res) => {
        const dadosTratados = this.tratarDados(res);
        const worksheet = XLSX.utils.json_to_sheet(dadosTratados);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        this.saveAsExcelFile(workbook, this.nomeModulo);

      },
      error: (error) => {
        this.messageService.add({ key: 'tipo', severity: 'error', summary: 'Erro', detail: 'Export Excel sem dados ' + error, life: 3000 });
      }
    });
  }

  private tratarDados(dados: any[]): any[] {
    const colunasDesejadas = ['codigoDealer', 'nomeDealer', 'processo', 'versao', 'versaoScript', 'usuarioVerificou', 'dataVerificacao', 'precisaAtualizar', 'ultimaComunicacao', 'status'];
    return dados.map(dado => {
      let novoDado = {};
      colunasDesejadas.forEach(coluna => {
        novoDado[coluna] = dado.hasOwnProperty(coluna) ? dado[coluna] : '';
      });
      return novoDado;
    });
  }
  

  customSort(event: any) {
    event.data.sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      const result = event.field === 'versaoScript' || event.field === 'versao'
        ? this.compararVersao(value1, value2)
        : this.compararPadrao(value1, value2);
      return event.order * result;
    });
  }

  private compararVersao(value1: any, value2: any): number {
    if (value1 == null && value2 == null) {
      return 0;
    }
    if (value1 == null) {
      return -1;
    }
    if (value2 == null) {
      return 1;
    }
    const partes1 = String(value1).split('.').map(parte => parseInt(parte, 10) || 0);
    const partes2 = String(value2).split('.').map(parte => parseInt(parte, 10) || 0);
    const tamanho = Math.max(partes1.length, partes2.length);
    for (let i = 0; i < tamanho; i++) {
      const diferenca = (partes1[i] || 0) - (partes2[i] || 0);
      if (diferenca !== 0) {
        return diferenca;
      }
    }
    return 0;
  }

  private compararPadrao(value1: any, value2: any): number {
    if (value1 == null && value2 == null) {
      return 0;
    }
    if (value1 == null) {
      return -1;
    }
    if (value2 == null) {
      return 1;
    }
    if (typeof value1 === 'string' && typeof value2 === 'string') {
      return value1.localeCompare(value2);
    }
    return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
  }

  private saveAsExcelFile(workbook: any, fileName: string): void {
    XLSX.writeFile(workbook, `${fileName}_export_${new Date().getTime()}.xlsx`);
  }

  getTranslate(value) {

    if (value.status === 'ATIVO') {
      return value.status = 'status.servico.statusGrid.ativo';
    }

    if (value.status === 'INATIVO') {
      return value.status = 'status.servico.statusGrid.inativo';
    }

    if (value.status === 'Erro') {
      return value.status = 'status.servico.statusGrid.erro';
    }

    if (value.status === 'EM DIA') {
      return value.status = 'status.servico.statusGrid.em_dia';
    }

    if (value.status === 'ATRASADO') {
      return value.status = 'status.servico.statusGrid.atrasado';
    }

    return this.dadosTranslate[value];
  }

  getColor(index: any): string {
    let inativo: string = "#FF0000";
    let erro: string = "#FFFF00";
    let ativo: string = "#008000";
    let atrasado: string = "#FF0000";
    let em_dia: string = "#008000";

    if (index === "status.servico.statusGrid.inativo") {
      return inativo;
    } else if (index === "status.servico.statusGrid.erro") {
      return erro;
    } else if (index === "status.servico.statusGrid.ativo") {
      return ativo;
    } else if (index === "status.servico.statusGrid.atrasado") {
      return atrasado;
    } else if (index === "status.servico.statusGrid.em_dia") {
      return em_dia;
    }
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
    this.getTranslate('');
    this.cdRef.detectChanges();
  }

}
